import { __awaiter } from '../../../../external_node_modules/tslib/tslib.es6.js';
import { getStorefrontByPlatform } from '../../../../api/storefront.js';
import { PLATFORMS } from '../../../../constants/platforms.js';

function getMockedOffers(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const storefront = yield getStorefrontByPlatform(PLATFORMS.EGS, customStorefrontName);
        const products = Object.values(storefront.products || {});
        return products.map((product) => {
            var _a, _b;
            return ({
                offerId: product.externalProductId,
                title: product.title,
                currencyCode: product.currency,
                currentPrice: product.price,
                originalPrice: product.originalPrice,
                discountPercentage: String(product.discount),
                expirationTimestamp: 'string',
                bAvailableForPurchase: '1',
                purchasedCount: ((_a = product.limitedQuantity) === null || _a === void 0 ? void 0 : _a.personalCount) ? String(product.limitedQuantity.personalCount) : '0',
                purchaseLimit: ((_b = product.limitedQuantity) === null || _b === void 0 ? void 0 : _b.personalLimit) ? String(product.limitedQuantity.personalLimit) : '0',
                items: [],
            });
        });
    });
}
function getMockedEpicStoreAccountId() {
    return __awaiter(this, void 0, void 0, function* () {
        return { accountId: '1' };
    });
}

export { getMockedEpicStoreAccountId, getMockedOffers };
//# sourceMappingURL=mock.js.map
